import React from "react";
import { motion } from "framer-motion";
import { Clock, BadgeCheck, UserCheck, PlaneLanding, Baby, Languages, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n";

const icons = [Clock, BadgeCheck, UserCheck, PlaneLanding, Baby, Languages];
// bento spans for 3-col grid: wide, single, single, single, single, wide
const spans = [
  "sm:col-span-2 lg:col-span-2",
  "lg:col-span-1",
  "lg:col-span-1",
  "lg:col-span-1",
  "lg:col-span-1",
  "sm:col-span-2 lg:col-span-3",
];

export const Benefits = () => {
  const { t } = useI18n();
  const items = t("benefits.items");

  return (
    <section id="benefits" className="relative py-14 sm:py-18 lg:py-24 overflow-hidden" data-testid="benefits-section">
      <div className="mesh-glow top-10 right-[-10rem]" />
      <div className="relative max-w-6xl xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-[-0.01em]">{t("benefits.title")}</h2>
          <p className="mt-3 text-muted-foreground">{t("benefits.subtitle")}</p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.isArray(items) && items.map((it, i) => {
            const Icon = icons[i % icons.length];
            const wide = i === 0 || i === items.length - 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative rounded-[18px] border border-border glass edge-light gold-glow p-6 ${spans[i] || ""}`}
                data-testid={`benefit-tile-${i}`}
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-secondary ring-1 ring-[hsl(42_50%_45%/0.25)]">
                    <Icon className="h-5 w-5 text-accent" />
                  </span>
                  <ArrowUpRight className="h-4 w-4 text-muted-foreground/50 group-hover:text-accent transition-colors" />
                </div>
                <h3 className={`mt-5 font-display font-semibold ${wide ? "text-2xl" : "text-xl"}`}>{it.t}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-md">{it.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
